import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/redchilunbi.png'
import _imports_1 from '@/assets/icon/zip.png'
import _imports_2 from '@/assets/icon/ziperror.png'
import _imports_3 from '@/assets/image/ZIPwenjian.png'
import _imports_4 from '@/assets/image/ZIP.png'
import _imports_5 from '@/assets/image/Union-1.png'
import _imports_6 from '@/assets/image/Union-2.png'
import _imports_7 from '@/assets/image/jiahao.png'
import _imports_8 from '@/assets/image/sanwei.png'
import _imports_9 from '@/assets/image/erwei.png'
import _imports_10 from '@/assets/image/BOM.png'
import _imports_11 from '@/assets/image/canshu.png'
import _imports_12 from '@/assets/image/huisejiantou.png'
import _imports_13 from '@/assets/image/Soildworks.png'
import _imports_14 from '@/assets/image/ug.png'
import _imports_15 from '@/assets/image/proe.png'
import _imports_16 from '@/assets/image/CATIA.png'
import _imports_17 from '@/assets/image/soli.png'
import _imports_18 from '@/assets/image/Inventor.png'


const _withScopeId = n => (_pushScopeId("data-v-71910fe3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "information" }
const _hoisted_2 = { class: "category" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "方案类别", -1))
const _hoisted_4 = { class: "earnings" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "预计获得收益", -1))
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "size" }, "允许上传文件大小", -1))
const _hoisted_9 = {
  key: 0,
  class: "big"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "download" }, "附件下载", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, "", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "replenish" }, "(填写后放入压缩文件中随作品上传)", -1))
const _hoisted_14 = { class: "original" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "原创声明", -1))
const _hoisted_16 = { class: "uploadbox" }
const _hoisted_17 = {
  key: 0,
  class: "el-upload__text"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text-title" }, " 将压缩文件拖拽至框内上传(ZIP、RAR) ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text-yun" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont el-upload__text-yun-iconfont" }, "")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 提交成功后需通过审核,审核时间:自提交后3个工作日内,节假日除外。若审核不通过,会通过站内信息提醒;请注意查收您的站内信息 ", -1))
const _hoisted_21 = { class: "el-upload__text-down" }
const _hoisted_22 = {
  key: 1,
  class: "el-upload__text"
}
const _hoisted_23 = { class: "el-upload__ing-titel" }
const _hoisted_24 = {
  key: 0,
  src: _imports_1
}
const _hoisted_25 = {
  key: 1,
  src: _imports_2
}
const _hoisted_26 = { class: "el-upload__ing-titel-span" }
const _hoisted_27 = {
  key: 0,
  class: "el-upload__info-show"
}
const _hoisted_28 = { class: "el-upload__ing-titel-span" }
const _hoisted_29 = { class: "el-upload__ing-titel-span" }
const _hoisted_30 = {
  key: 1,
  class: "el-upload__info-show"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "el-upload__ing-titel-span el-upload__ing-titel-span-lan" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-chenggong1" }),
  /*#__PURE__*/_createTextVNode("上传成功")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-huabanfuben" }, null, -1))
const _hoisted_33 = {
  key: 1,
  class: "el-upload__info-show el-upload__info-show-error"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "el-upload__ing-titel-span el-upload__ing-titel-span-red" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-shibai" }),
  /*#__PURE__*/_createTextVNode("上传失败")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-huabanfuben" }, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "并承诺所上传作品为原创", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notice" }, "上传须知", -1))
const _hoisted_38 = { class: "gray" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "末端执行器20220723.zip", -1))
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<div class=\"one\" data-v-71910fe3> 1.作品命名规范 <div class=\"one-box\" data-v-71910fe3><img src=\"" + _imports_4 + "\" alt=\"\" class=\"img1\" data-v-71910fe3><div class=\"type\" data-v-71910fe3>末端执行器  20220723</div><div data-v-71910fe3><img src=\"" + _imports_5 + "\" alt=\"\" class=\"img2\" data-v-71910fe3><img src=\"" + _imports_6 + "\" alt=\"\" class=\"img3\" data-v-71910fe3></div><span class=\"product\" data-v-71910fe3>产品类型</span><img src=\"" + _imports_7 + "\" alt=\"\" class=\"img4\" data-v-71910fe3><span class=\"time\" data-v-71910fe3>日期</span><div class=\"paragraph\" data-v-71910fe3><p class=\"p1\" data-v-71910fe3><i class=\"iconfont\" data-v-71910fe3></i> 作品缺少以下文件将进行退稿处理 ,待完善后可重新上传。 </p><p class=\"p2\" data-v-71910fe3><i class=\"iconfont\" data-v-71910fe3></i> 作品中不得包含任何谩骂、诅咒、诋毁、攻击内容 以及违反国家强制性法律法规的内容; </p><p class=\"p3\" data-v-71910fe3>    不得包含任何计算机病毒、后门以及可以预见得到的明显的漏洞(BUG) </p></div></div></div><div class=\"two\" data-v-71910fe3> 2.作品要包含BOM文件、二维文件、三维文件、产品说明及技术参数 </div><div class=\"two-box\" data-v-71910fe3><div class=\"name\" data-v-71910fe3><span data-v-71910fe3> 文件夹名称: </span><div class=\"file\" data-v-71910fe3><img src=\"" + _imports_8 + "\" alt=\"\" data-v-71910fe3><p data-v-71910fe3>三维文件</p></div><img src=\"" + _imports_7 + "\" alt=\"\" class=\"jiahao\" data-v-71910fe3><div class=\"file\" data-v-71910fe3><img src=\"" + _imports_9 + "\" alt=\"\" data-v-71910fe3><p data-v-71910fe3>二维文件</p></div><img src=\"" + _imports_7 + "\" alt=\"\" class=\"jiahao\" data-v-71910fe3><div class=\"file\" data-v-71910fe3><img src=\"" + _imports_10 + "\" alt=\"\" data-v-71910fe3><p class=\"p1\" data-v-71910fe3>产品名称+采购清单(BOM)文件</p></div><img src=\"" + _imports_7 + "\" alt=\"\" class=\"jiahao\" data-v-71910fe3><div class=\"file\" data-v-71910fe3><img src=\"" + _imports_11 + "\" alt=\"\" data-v-71910fe3><p class=\"p2\" data-v-71910fe3>产品说明及技术参数</p></div></div><div class=\"jiantou\" data-v-71910fe3><img src=\"" + _imports_12 + "\" alt=\"\" class=\"img1\" data-v-71910fe3><img src=\"" + _imports_12 + "\" alt=\"\" class=\"img2\" data-v-71910fe3><img src=\"" + _imports_12 + "\" alt=\"\" class=\"img3\" data-v-71910fe3><img src=\"" + _imports_12 + "\" alt=\"\" class=\"img4\" data-v-71910fe3></div><div class=\"juti\" data-v-71910fe3><span data-v-71910fe3>具体文件:</span><div class=\"chunk\" data-v-71910fe3><p class=\"p1\" data-v-71910fe3>SQRC2 8-02</p><p class=\"p2\" data-v-71910fe3>单向阀.sldprt</p></div><div class=\"chunk1\" data-v-71910fe3><p class=\"p1\" data-v-71910fe3>SQRC2 8-02</p><p class=\"p2\" data-v-71910fe3>单向阀.dwg</p></div><div class=\"chunk2\" data-v-71910fe3><p class=\"p1\" data-v-71910fe3>末端执行器</p><p class=\"p2\" data-v-71910fe3>采购清单.xlsx</p></div><p data-v-71910fe3>产品说明及技术参数.xlsx</p></div><div class=\"img\" data-v-71910fe3><div class=\"duiying\" data-v-71910fe3><img src=\"" + _imports_5 + "\" alt=\"\" class=\"img2\" data-v-71910fe3><img src=\"" + _imports_6 + "\" alt=\"\" class=\"img3\" data-v-71910fe3></div><div class=\"duiying1\" data-v-71910fe3><img src=\"" + _imports_5 + "\" alt=\"\" class=\"img2\" data-v-71910fe3><img src=\"" + _imports_6 + "\" alt=\"\" class=\"img3\" data-v-71910fe3></div><div class=\"duiying2\" data-v-71910fe3><img src=\"" + _imports_5 + "\" alt=\"\" class=\"img2\" data-v-71910fe3><img src=\"" + _imports_6 + "\" alt=\"\" class=\"img3\" data-v-71910fe3></div></div><div class=\"blues\" data-v-71910fe3><div class=\"blueone\" data-v-71910fe3><span class=\"product\" data-v-71910fe3>零件型号</span><img src=\"" + _imports_7 + "\" alt=\"\" data-v-71910fe3><span class=\"time\" data-v-71910fe3>名称</span></div><div class=\"bluetwo\" data-v-71910fe3><span class=\"product\" data-v-71910fe3>零件型号</span><img src=\"" + _imports_7 + "\" alt=\"\" data-v-71910fe3><span class=\"time\" data-v-71910fe3>名称</span></div><div class=\"bluethree\" data-v-71910fe3><span class=\"product\" data-v-71910fe3>产品名称</span><img src=\"" + _imports_7 + "\" alt=\"\" data-v-71910fe3><span class=\"time\" data-v-71910fe3>采购清单</span></div></div><div class=\"paragraph\" data-v-71910fe3><p class=\"p1\" data-v-71910fe3><i class=\"iconfont\" data-v-71910fe3></i> 作品具体文件需分别整理放到对应的文件夹里,文件夹名称如上图所示。 </p><p class=\"p2\" data-v-71910fe3><i class=\"iconfont\" data-v-71910fe3></i> 具体文件名称命名注意事项： </p><p class=\"p3\" data-v-71910fe3>   1、上传的二维图、三维图的具体文件命名:以型号+名称的形式来命名,型号与名称中间需要加空格。 </p><p class=\"p4\" data-v-71910fe3>   2、BOM表中的零件名称、三维图名称、二维图名称需保持一致。采购BOM主要包含零件（加工件、标准件）型号、名称、数量、标准件品牌（供应商）4项内容。 </p></div></div><div class=\"three\" data-v-71910fe3>3.三维文件上传要求及格式说明</div><div class=\"three-box\" data-v-71910fe3><div class=\"icon\" data-v-71910fe3><div class=\"phone1\" data-v-71910fe3><img src=\"" + _imports_13 + "\" alt=\"\" data-v-71910fe3><p data-v-71910fe3>Soildworks</p></div><div class=\"phone2\" data-v-71910fe3><img src=\"" + _imports_14 + "\" alt=\"\" data-v-71910fe3><p data-v-71910fe3>UG</p></div><div class=\"phone3\" data-v-71910fe3><img src=\"" + _imports_15 + "\" alt=\"\" data-v-71910fe3><p data-v-71910fe3>Proe/Creo</p></div><div class=\"phone4\" data-v-71910fe3><img src=\"" + _imports_16 + "\" alt=\"\" data-v-71910fe3><p data-v-71910fe3>CATIA</p></div><div class=\"phone5\" data-v-71910fe3><img src=\"" + _imports_17 + "\" alt=\"\" data-v-71910fe3><p data-v-71910fe3>SoliEdge</p></div><div class=\"phone6\" data-v-71910fe3><img src=\"" + _imports_18 + "\" alt=\"\" data-v-71910fe3><p data-v-71910fe3>Inventor</p></div></div><div class=\"paragraph\" data-v-71910fe3><p class=\"p1\" data-v-71910fe3><i class=\"iconfont\" data-v-71910fe3></i> 支持以上设计软件导出文件格式 </p><p class=\"p2\" data-v-71910fe3><i class=\"iconfont\" data-v-71910fe3></i> 上传的是装配体,对应的零部件也一定要上传,否则模型无法正常打开,将进行退稿处理。 </p><p class=\"p3\" data-v-71910fe3><i class=\"iconfont\" data-v-71910fe3></i> 保证上传三维文件的完整性 </p></div></div>", 5)
const _hoisted_46 = { class: "viprecord" }
const _hoisted_47 = { class: "title" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "原创承诺书", -1))
const _hoisted_49 = { class: "record" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "boxs" }, " 本人已完全阅读、理解并接受设纪元的各项协议及规则，现就设纪元中本人所上传的作品，承诺如下: ", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 1、本人在设纪元上传的所有作品均系自己的原创作品或已经取得权利人的完全授权，不存在任何权属纠纷； ", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 2、因本人上传、展示的作品侵权产生的全部法律责任及经济损失由本人承担，追责以本人实名认证的信息为准; ", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3、本人将作品上传至设纪元即视为同意用户通过付费获得许可；", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 4、本人对之前上传的所有作品承担本声明中同等的法律责任并予以同等的授权许可。 ", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "boxs" }, " 本人承诺上传至设纪元的作品权属声明与此说明内容一致，是本人的真实意思表示 ", -1))
const _hoisted_56 = { class: "viprecord" }
const _hoisted_57 = { class: "title" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "评价机制", -1))
const _hoisted_59 = { class: "records" }
const _hoisted_60 = { class: "title1" }
const _hoisted_61 = { style: {"display":"flex"} }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "作品收益提现", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "资料评价机制逐步完善，目前执行以下规则：", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, "资料名称"),
  /*#__PURE__*/_createElementVNode("div", { class: "contain" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "contop" }, "资料完整度"),
    /*#__PURE__*/_createElementVNode("div", { class: "confoot" }, [
      /*#__PURE__*/_createElementVNode("p", null, "0.8"),
      /*#__PURE__*/_createElementVNode("p", null, "0.9"),
      /*#__PURE__*/_createElementVNode("p", { class: "p1" }, "1"),
      /*#__PURE__*/_createElementVNode("p", { style: {"border-right":"none"} }, "说明")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "right" }, "技术含量")
], -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "left1" }, "三维图"),
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/_createElementVNode("p", null, "遗漏或缺失零部件，设纪元可根据二维图补充的，可采用。")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/_createElementVNode("p", null, "仅缺少紧固件 （例：螺栓）可采用")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "left1" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "p1" }, "零件完整，装配完全。")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/_createElementVNode("p", null, " 三维图为可更改源文件（外购零件可为输入格式），装配体不得穿模，红色报错。需要保证三维文件的完整性与正确性。 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/_createElementVNode("p", null, " 从产品的设计思路、结构的巧妙程度、实际应用能力等多方面进行评价，评价越高，获得收益越多。 ")
  ])
], -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "left1" }, "二维图"),
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/_createElementVNode("p", null, " 缺少部分标准件再加工图纸，设纪元可根据三维图补充的，可采用。 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/_createElementVNode("p", null, "仅缺少零件的数量、图框 信息，可采用")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "left1" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "p1" }, "零件完整，装配完全。")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/_createElementVNode("p", null, " 二维图为DWG格式文件，尺寸标注完整、正确。与三维图相互对应，保证文件的完整性与正确性。 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/_createElementVNode("p", null, " 从图纸尺寸标注的准确性、规范性、完整性等方面进行评价，评价越高，获得收益越高。 ")
  ])
], -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "left1" }, "机械采购BOM"),
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/_createElementVNode("p", null, " 缺少加工件、零件的数量，设纪元可根据三维图、二维图补充的，可采用。 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/_createElementVNode("p", null, "仅缺少品牌，可采用")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "left1" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "p1" }, "表格内容完整无缺。")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/_createElementVNode("p", null, " 从产品结构的复杂、新颖程度，零件数量，实践度等多方面进行评价，评价越高，获得收益越多。 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/_createElementVNode("p", null, " 包含零件（加工件、标准件）型号、名称、数量、标准件品牌。表格准确完整程度越高，获得收益越多。 ")
  ])
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "left1" }, "产品说明及技术参数表"),
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/_createElementVNode("p", null, " 缺少部分零件基础参数，设纪元可根据三维图、二维图补充的，可采用。 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/_createElementVNode("p", null, "仅缺少产品分类，可采用")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "left1" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "p1" }, "表格内容完整无缺。")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/_createElementVNode("p", null, " 下载《产品说明及技术参数表》，填写与所上传作品类别对应的表格，保证内容的完整性与正确性。 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/_createElementVNode("p")
  ])
], -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "foot" }, " 注：1、投稿作品须为上传作者本人原创或已获得完全版权。2、如投稿作品与本站已有设计方案重复，作品审核不予通过。 ", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("template", null, null, -1))
const _hoisted_71 = { class: "viprecord" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-yk_gantanhao_fill" }, null, -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "个人认证后可上传作品", -1))
const _hoisted_74 = { class: "go" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "去认证", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_InvoiceDialog = _resolveComponent("InvoiceDialog")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Title = _resolveComponent("Title")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: _ctx.worksForm,
        rules: _ctx.rules,
        ref: "ruleFormRef"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              (_ctx.worksForm.radio != '')
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : _createCommentVNode("", true),
              (_ctx.worktype.data && _ctx.worktype.data.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.changeMoney(_ctx.worktype, _ctx.worksForm)), 1))
                : _createCommentVNode("", true),
              (_ctx.worksForm.radio != '')
                ? (_openBlock(), _createElementBlock("i", {
                    key: 2,
                    class: "iconfont",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setDialogVisibles()))
                  }, ""))
                : _createCommentVNode("", true),
              (_ctx.worksForm.radio != '')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setDialogVisibles()))
                  }, " 评价机制 "))
                : _createCommentVNode("", true)
            ]),
            _hoisted_8,
            (
						_ctx.worksForm.radio != '' && _ctx.worktype.data && _ctx.worktype.data.length > 0
					)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 不超过" + _toDisplayString(_ctx.worksize(_ctx.worktype, _ctx.worksForm)) + "MB ", 1))
              : _createCommentVNode("", true)
          ]),
          _hoisted_10,
          _createElementVNode("div", {
            class: "blue",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.downloads && _ctx.downloads(...args)))
          }, _hoisted_12),
          _createElementVNode("div", {
            class: "explain",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.downloads && _ctx.downloads(...args)))
          }, "上传文件说明及技术参数表"),
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_el_form_item, { prop: "work" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_el_upload, {
                    class: "upload-demo",
                    drag: "",
                    action: _ctx.updateUrl,
                    "before-upload": _ctx.beforeUpload,
                    data: _ctx.additional,
                    "on-progress": _ctx.handelProgress,
                    multiple: "",
                    disabled: _ctx.worksForm.work.length > 0,
                    "file-list": _ctx.worksForm.work,
                    "onUpdate:fileList": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.worksForm.work) = $event)),
                    accept: ".ZIP,.RAR,.zip,.rar,.tar,.TAR"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.worksForm.work.length == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _hoisted_18,
                            _hoisted_19,
                            _hoisted_20,
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_el_button, { class: "submit" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("上传作品")
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              (!_ctx.uploadError)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                                : (_openBlock(), _createElementBlock("img", _hoisted_25)),
                              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.worksForm.work[0].name), 1)
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["el-upload__handelProgress", { 'el-upload__handelProgress-error': _ctx.uploadError }])
                            }, [
                              _createElementVNode("div", {
                                class: "el-upload__handelProgress-ing",
                                style: _normalizeStyle({ width: _ctx.progressWidth + 'px' })
                              }, null, 4)
                            ], 2),
                            (!_ctx.uploadError)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_ctx.handepro != 100)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.upTotal) + "MB/" + _toDisplayString(_ctx.fileTotal) + "MB", 1),
                                        _createElementVNode("span", _hoisted_29, "上传中" + _toDisplayString(_ctx.handepro) + "%", 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                        _hoisted_31,
                                        _createElementVNode("span", {
                                          class: "el-upload__ing-titel-span",
                                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeUpdate && _ctx.changeUpdate(...args)))
                                        }, [
                                          _hoisted_32,
                                          _createTextVNode("修改")
                                        ])
                                      ]))
                                ], 64))
                              : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                  _hoisted_34,
                                  _createElementVNode("span", {
                                    class: "el-upload__ing-titel-span",
                                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeUpdate && _ctx.changeUpdate(...args)))
                                  }, [
                                    _hoisted_35,
                                    _createTextVNode("重新上传")
                                  ])
                                ]))
                          ]))
                    ]),
                    _: 1
                  }, 8, ["action", "before-upload", "data", "on-progress", "disabled", "file-list"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "radio",
              class: "worktype"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.worksForm.radio,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.worksForm.radio) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.worktype.data, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_radio, {
                        label: item.names,
                        name: "type"
                      }, null, 8, ["label"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "agreement",
              class: "shengming"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.worksForm.agreement,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.worksForm.agreement) = $event)),
                  label: "我已阅读",
                  name: "agreement",
                  style: {"margin-top":"12px","margin-left":"335px"},
                  class: "ikonw"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef))),
                  class: "routine submit"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("提交")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", {
              class: "div1",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setDialogVisible()))
            }, "《原创承诺书》"),
            _hoisted_36
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _hoisted_37,
      _createElementVNode("div", _hoisted_38, [
        _hoisted_39,
        _hoisted_40,
        _createElementVNode("div", {
          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args)))
        }, "下载样例")
      ]),
      _hoisted_41
    ]),
    _createVNode(_component_InvoiceDialog, {
      ref: "sonRef",
      style: {"top":"200px"}
    }, {
      default: _withCtx(({}) => [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createElementVNode("i", {
              class: "iconfont",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.mclose()))
            }, "")
          ]),
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _hoisted_51,
            _hoisted_52,
            _hoisted_53,
            _hoisted_54,
            _hoisted_55,
            _createElementVNode("button", {
              class: "routine",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.know && _ctx.know(...args)))
            }, "我已阅读并承诺")
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_InvoiceDialog, {
      ref: "sonRefs",
      dialogwidth: "580px",
      class: "tongzhi"
    }, {
      default: _withCtx(({}) => [
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _hoisted_58,
            _createElementVNode("i", {
              class: "icon iconfont icon-shanchu",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.mcloses()))
            })
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _createTextVNode(" 资料完整度、技术含量越高，获得的作品收益越高，作品获得的收益可申请提现，具体请查看“ "),
                _createVNode(_component_router_link, { to: {
									name: 'guidance',
									params: {
										comName: 'Earnings',
									},
								} }, {
                  default: _withCtx(() => [
                    _hoisted_62
                  ]),
                  _: 1
                }),
                _createTextVNode(" ”， ")
              ]),
              _hoisted_63
            ]),
            _hoisted_64,
            _hoisted_65,
            _hoisted_66,
            _hoisted_67,
            _hoisted_68,
            _hoisted_69
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_InvoiceDialog, {
      ref: "sonRefes",
      dialogwidth: "580px",
      class: "qurenzheng"
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Title, {
          headerHeight: 40,
          headerBC: "#F2F5FA"
        }, {
          default: _withCtx(() => [
            _hoisted_70
          ]),
          _: 1
        })
      ]),
      default: _withCtx(({}) => [
        _createElementVNode("div", _hoisted_71, [
          _hoisted_72,
          _hoisted_73,
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("p", {
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.mclosees()))
            }, "取消"),
            _createVNode(_component_router_link, { to: "/user/selfverify" }, {
              default: _withCtx(() => [
                _hoisted_75
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}